export default __webpack_public_path__ + "static/media/RTVM.0bed5c3a.png";